<template>
  <el-row style="height: 100%;" class="customPersonDialogBodyClass">
    <el-col :style="{ padding: getPadding(),height:getRows()}"
      class="column" :span="getColumns()" v-for="(item, index) in listPerson" :key="index">
      <div style="width:100%;height:100%" :style="{backgroundColor:chartConfig.backgroundColor,
       backgroundImage:chartConfig.backgroundImage,border:chartConfig.border}">
        <div style="display: flex;" :style="{fontSize:getFontSize(),color:chartConfig.color}" >
          <div style="align-self: center;text-align:center;width: 35%;">
            <img style="width: 70%;" :src="getImage(item)" />
          </div>
          <div style="flex: 1;">
            <el-row class="item" :style="{marginTop:getItemMarginTop()}">
              <el-col :span="8" style="text-align: right;">
                姓名:
              </el-col>
              <el-col :span="16" style="padding-left:10px;">
                {{item.name}}
              </el-col>
            </el-row>
            <el-row class="item" :style="{marginTop:getItemMarginTop()}">
              <el-col :span="8" style="text-align: right;">
                工号:
              </el-col>
              <el-col :span="16" style="padding-left:10px;">
                {{item.gh}}
              </el-col>
            </el-row>
            <el-row class="item" :style="{marginTop:getItemMarginTop()}">
              <el-col :span="8" style="text-align: right;">
                电话:
              </el-col>
              <el-col :span="16" style="padding-left:10px;">
                {{item.telphone?item.telphone:'无'}}
              </el-col>
            </el-row>
          </div>
          <div>
            <el-checkbox true-label="1" false-label="0" @change="personChange" size="mini" v-model="item['selectId']"
              style="background-color: rgba(0,0,0,0);"></el-checkbox>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
  import {
    getDataService
  } from '../../api/chart/chart/index.js'
  import fwUtil from 'framework-util'
  export default {
    props: {
      width: {
        type: String,
        default: "180px",
      },
      height: {
        type: String,
        default: "30px",
      },
      listData: {
        type: Array,
        default () {
          return []
        }
      },
      queryConfig: {
        type: Object,
        default () {
          return {
            url: null,
            params: []
          }
        }
      },
      screen: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280
          }
        }
      },
      page: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280,
          }
        }
      },
      chartConfig: {
        type: Object,
        default: function() {
          return {
            columns: 1,
            padding: "10px",
            url: '',
            selectId: [],
            fontSize: 14,
            backgroundColor: null,
            border: null,
            backgroundImage: null,
            color: "#000000"

          };
        }
      }
    },
    data() {
      return {
        listPerson: [],
        rows: 1,
        data: {
          gh: '张三',
          name: '姓名',
          telphone: "17705181062"
        }
      }
    },
    mounted() {
      this.getData()
    },
    watch: {
      queryConfig: {
        handler(newValue, oldValue) {
          console.info("queryConfig")
          this.getData()
        },
        deep: true
      }
    },
    methods: {
      getImage(item) {
        if (item.imageUrl) {
          return item.iamgeUrl
        }
        return this.getNoHeaderImage()
      },
      getNoHeaderImage() {
        return "data:image/png;base64,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"
      },
      getFontSize() {
        let _height = this.chartConfig.fontSize ? this.chartConfig.fontSize : 14;
        let height = _height / this.page.width * this.screen.width
        return height + 'px'
      },
      personChange() {
        this.$emit("data", this.listPerson)
      },
      getRows() {
        let _rows = this.chartConfig.rows ? this.chartConfig.rows : 1
        return (100 / _rows) + '%'
      },
      getColumns() {
        if (!this.chartConfig.columns) {
          return 24
        }
        return 24 / this.chartConfig.columns
      },
      getData() {
        this.listPerson = []
        if (!this.queryConfig.url) {
          if (this.listData) {
            for (let i = 0; i < this.listData.length; i++) {
              this.listPerson.push(this.listData[i])
            }
          }

          return;
        }
        let that = this

        if (this.queryConfig && this.queryConfig.url) {
          let url = this.queryConfig.url
          let params = {}
          console.info("查询参数")
          console.info(this.queryConfig.params)
          if (this.queryConfig.params) {
            for (let i = 0; i < this.queryConfig.params.length; i++) {
              if (this.queryConfig.params[i].target &&
                this.queryConfig.params[i].source) {
                let _value = fwUtil.Helper.GetQueryString(this.queryConfig.params[i].source)
                console.info("查询参数值==" + _value)
                if (_value) {
                  params[this.queryConfig.params[i].target] = _value
                }
              }
            }
          }
          getDataService(url, params).then((res) => {
            console.info(that.listPerson)
            if (res && res.length > 0) {
              for (let i = 0; i < res.length; i++) {
                that.listPerson.push(res[i])
              }
            }
            let _columns = this.chartConfig.columns ? this.chartConfig.columns : 1;
            let _rows = parseInt(that.listPerson.length / _columns)
            if ((this.listPerson.length % _columns) > 0) {
              _rows += 1
            }
            console.info("个人头像数据绑定成功")
            //that.$set(that.rows,_rows)
            that.rows = _rows
            if (that.listPerson) {
              for (let i = 0; i < that.listPerson.length; i++) {
                that.listPerson[i].selectId = "0"
              }
            }
          })

        }
      },
      getItemMarginTop(){
        if(this.screen.width<2000){
          return '10px'
        }else{
          return (this.screen.height/2000)*10+'px'
        }
      },
      getPadding() {
        let _height = this.chartConfig.padding ? this.chartConfig.padding : "0"
        if (_height.toString().indexOf('px') >= 0) {
          _height = _height.toString().replace("px", "")
        }
        if (_height.toString().indexOf("%") >= 0) {
          _height = _height.toString().replace("%", "")
        }
        _height = parseInt(_height)
        let height = _height / this.page.width * this.screen.width
        return height + 'px'

      }
    }

  }
</script>

<style scoped="scoped">
  .customPersonDialogBodyClass {
    opacity: 1;
  }

  .customPersonDialogBodyClass .column {
    background-repeat: no-repeat;
    background-size: 100%100%;
    -webkit-background-size: 100%100%;
    -o-background-size: 100%100%;
  }

  .customPersonDialogBodyClass .item {
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/images/personImages.vue